import React from 'react'
import { AutocompleteHOC } from '../../hocs'
import Suggest from '../../components/ESSearch/Suggest'
import LanguageProvider from '../../containers/LanguageProvider/LanguageProvider'
import messages from './messages'

const SuggestContainer = ({
  suggestions,
  value,
  handleSelect,
  handleSubmit,
  handleClear,
  isFetching,
  language,
  searchPlaceholder,
  onSuggestionsClearRequested,
  onChange,
  isInModal,
  showSuggestions
}) => {
  const onSuggestionsFetchRequested = ({ value }) => {}
  const getSuggestionValue = suggestion => suggestion

  const inputProps = {
    placeholder: searchPlaceholder || messages[language]['search'],
    value,
    onChange,
    // Autofocus when search is empty (opened from header) but not when
    // submitted with value from home input
    autoFocus: !value
  }

  const autosuggestProps = {
    inputProps,
    onSuggestionSelected: handleSelect,
    onSuggestionsFetchRequested,
    onSuggestionsClearRequested,
    suggestions: [{ title: isInModal ? 'Matching searches' : null, suggestions }],
    getSuggestionValue,
    shouldRenderSuggestions: (val) => showSuggestions && val.trim().length > 2,
  }
  const props = {
    autosuggestProps,
    clearHandler: handleClear,
    submitHandler: handleSubmit,
    isFetching
  }
  return <Suggest {...props} />
}

export default LanguageProvider(AutocompleteHOC(SuggestContainer))



// WEBPACK FOOTER //
// ./src/containers/ESSearch/Suggest.js